export const getInitialEmailMode = (pathname: string): 'login' | 'register' => (
  pathname === '/signup' ? 'register' : 'login'
);
